/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { Dropdown1 } from '../../../../_metronic/partials'
import { useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import { ProfileDetailsSearch } from "../components/Edit"
import { UploadExcel } from "../components/UploadExcel"
import axios from 'axios'
import '../../index.css'
export function AddPoint() {
  const location = useLocation();
  const [user, setUser] = useState<any>([])
  const [overviewTab, setOveriewTab] = useState<any>('active')
  const [settingTab, setSettingTab] = useState<any>('')
  useEffect(
    () => {
      console.log(location)
      setUser(location.state)
    },
    [] // Only re-call effect if value or delay changes
  )
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <h1>เพิ่มคะแนน</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item' onClick={() => { setOveriewTab('active'); setSettingTab(''); }}>
              <span
                className={
                  `nav-link text-active-primary me-6 ` +
                  overviewTab
                }
              //to='/crafted/account/overview'
              >
                ค้นหาผู้ใช้
              </span>
            </li>
            {/*<li className='nav-item' onClick={() => { setSettingTab('active'); setOveriewTab(''); }}>
              <span
                className={
                  `nav-link text-active-primary me-6 ` +
                  settingTab
                }
              //to='/crafted/account/settings'
              >
                upload excel
              </span>
            </li>*/}
          </ul>
        </div>
      </div>
      {overviewTab ? <ProfileDetailsSearch /> : null}
      {settingTab ? <UploadExcel /> : null}
    </div>
  )
}

